export class AccessCardReady {
  id: number;
  newBadgeNumber: string;
  comments: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/access-card-ready.ts